import { syncMiSheberachCards } from '../msc-card-3d.js';

export default {
    loadMemberExpandPanelFragments($row) {
        if (!this.memberExpandPanelFragmentsRoute || !$row || !$row.length) return;

        const key = this.getRowKey($row);
        const $pledgesPanel = this.getDetailContainer($row, key, 'recent-pledges');
        const $miSheberachCardPanel = this.getDetailContainer($row, key, 'member-mi-sheberach-card');
        const $relationshipsPanel = this.getDetailContainer($row, key, 'member-relationships');
        const hasPledgesPanel = Boolean($pledgesPanel.length);
        const hasMiSheberachCard = Boolean($miSheberachCardPanel.length);
        const hasRelationshipsPanel = Boolean($relationshipsPanel.length);
        if (!key || (!hasPledgesPanel && !hasMiSheberachCard && !hasRelationshipsPanel)) return;

        const requestKey = `expand-panels-${key.id}`;

        const setPanelsError = (message) => {
            if (hasPledgesPanel) this.setErrorState($pledgesPanel, message);
            if (hasMiSheberachCard) this.setErrorState($miSheberachCardPanel, message);
            if (hasRelationshipsPanel) this.setErrorState($relationshipsPanel, message);
        };

        this.abortRequest(requestKey);
        if (hasPledgesPanel) this.setLoadingState($pledgesPanel, 'Loading...');
        if (hasMiSheberachCard) this.setLoadingState($miSheberachCardPanel, 'Loading...');
        if (hasRelationshipsPanel) this.setLoadingState($relationshipsPanel, 'Loading...');

        const jqXHR = $.ajax({
            url: this.memberExpandPanelFragmentsRoute.replace(':member_id', key.id),
            type: 'GET',
            success: (response) => {
                if (this.activeRequests[requestKey] !== jqXHR) return;
                delete this.activeRequests[requestKey];
                if (!response.success) {
                    setPanelsError(response.error || 'Failed to load');
                    return;
                }

                    const memberArchived = $row.attr('data-congregation-archive') === '1'
                        || Number($row.data('congregation-archive')) === 1;

                if (hasPledgesPanel) {
                    const $content = $(String(response.pledges_list_html).trim());
                    this.renderDetailPanelContent($pledgesPanel, $content);
                    const pledgesEmpty = $content.is('.member-recent-pledges-empty')
                        || $content.find('.member-recent-pledges-empty').length > 0;
                    this.setExpandSectionDisabled(
                        $pledgesPanel,
                        pledgesEmpty || memberArchived,
                        memberArchived ? null : ['view-all-pledges']
                    );
                }

                if (!hasMiSheberachCard && !hasRelationshipsPanel) return;

                if (hasRelationshipsPanel) {
                    const relationshipsFragment = String(response.relationships_fragment || '').trim();
                    this.renderRelationshipsPanelHtml($relationshipsPanel, relationshipsFragment);
                    if (memberArchived) {
                        this.setExpandSectionDisabled($relationshipsPanel, true);
                    }
                }

                if (!hasMiSheberachCard) return;

                const fragment = String(response.mi_sheberach_card_fragment || '').trim();
                this.renderRelationshipsPanelHtml($miSheberachCardPanel, fragment);
                this.setExpandSectionDisabled($miSheberachCardPanel, fragment === '' || memberArchived);
                syncMiSheberachCards($miSheberachCardPanel[0]);
            },
            error: (xhr) => {
                if (this.activeRequests[requestKey] !== jqXHR) return;
                delete this.activeRequests[requestKey];
                if (xhr.statusText !== 'abort') {
                    setPanelsError('Error loading. Please try again.');
                }
            },
        });
        this.activeRequests[requestKey] = jqXHR;
    },
};
